'use strict';

module.exports = {
  notStarted: 'not-started',
  inProgress: 'in-progress',
  failed: 'failed',
  complete: 'success',
};
